// Recuperação de "chunk obsoleto" após um deploy do frontend.
//
// O Vite gera hashes novos nos arquivos a cada build (ex.: AtivosListPage-DsYw2x0z.js).
// Quem está com a aba aberta durante um deploy continua com o index.html antigo em memória
// e, ao navegar para uma rota lazy, tenta baixar um chunk que não existe mais no servidor →
// 404 + "Failed to fetch dynamically imported module" e a rota quebra.
//
// A correção é recarregar a página uma vez ao detectar essa falha: o reload traz o index.html
// novo, que referencia os hashes atuais. O guard por timestamp evita loop infinito caso o
// chunk realmente não exista (ex.: rollback), recarregando no máximo uma vez a cada 10s.

const KEY = 'rocky_chunk_reload_ts';
const JANELA_MS = 10_000;

/** Recarrega a página no máximo uma vez a cada 10s (evita loop se o chunk sumiu de vez). */
export function reloadParaChunkObsoleto(): void {
  const ultimo = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - ultimo < JANELA_MS) return;
  sessionStorage.setItem(KEY, String(Date.now()));
  window.location.reload();
}

/** Heurística: o erro é de falha ao baixar um módulo dinâmico (chunk lazy)? */
export function ehErroDeChunk(err: unknown): boolean {
  const msg = err instanceof Error ? err.message : String(err ?? '');
  return /dynamically imported module|Importing a module script failed|Failed to fetch dynamically|error loading dynamically imported module|'text\/html'/i.test(msg);
}

/** Registra os listeners globais de recuperação (chamar uma vez no bootstrap). */
export function registrarRecuperacaoDeChunk(): void {
  // Evento oficial do Vite para falha de import dinâmico (disparado em produção).
  window.addEventListener('vite:preloadError', (e: Event) => {
    e.preventDefault();
    reloadParaChunkObsoleto();
  });
  // Fallback: quando a falha chega como promise rejeitada sem passar pelo helper do Vite.
  window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
    if (ehErroDeChunk(e.reason)) reloadParaChunkObsoleto();
  });
}
